// Operational collection rules are versioned independently of questionnaire 6.
export const COLLECTION_VERSION = 2;
export const BUS_LINES = Object.freeze([
  { value: "fortaleza-olho-dagua", label: "Fortaleza/Olho D’Água" },
  { value: "32206", label: "32206 – Fortaleza/Pitaguary", treatment_group: "pitaguari" },
  { value: "32101", label: "32101 – Fortaleza/Conjunto Carlos Jereissati (Rota 1)" },
  { value: "32102", label: "32102 – Fortaleza/Conjunto Carlos Jereissati (Rota 2)" },
  { value: "32201", label: "32201 – Fortaleza/Conjunto Novo Maracanaú" },
  { value: "32202", label: "32202 – Fortaleza/Conjunto Timbó" },
  { value: "32103", label: "32103 – Fortaleza/Taquara" },
  { value: "32204", label: "32204 – Fortaleza/Conjunto Acaracuzinho" }
]);

export function duplicateQuestion(approachType) {
  return {
    id: "recent_participation",
    label: `Nos últimos dias, você já respondeu, ${approachType === "ponto" ? "neste contexto de transporte" : "nesta linha de ônibus"}, a esta pesquisa sobre suas viagens e suas escolhas de transporte?`,
    options: [{ value: "nao", label: "Não" }, { value: "sim", label: "Sim" }]
  };
}

export function recordFlags(document) {
  let payload = document.payload_json || document;
  if (typeof payload === "string") {
    try { payload = JSON.parse(payload); } catch { payload = {}; }
  }
  return {
    is_test: document.is_test === true || payload.is_test === true,
    duplicate_attempt: document.duplicate_attempt === true || payload.duplicate_attempt === true
  };
}

export function isResearchRecord(document) {
  const flags = recordFlags(document);
  return !flags.is_test && !flags.duplicate_attempt;
}
